import { render, staticRenderFns } from "./UploadAnexo.vue?vue&type=template&id=631aebc2&scoped=true&lang=pug&"
import script from "./UploadAnexo.vue?vue&type=script&lang=js&"
export * from "./UploadAnexo.vue?vue&type=script&lang=js&"
import style0 from "./UploadAnexo.vue?vue&type=style&index=0&id=631aebc2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631aebc2",
  null
  
)

export default component.exports